/* eslint-disable camelcase */
export default class ClinicalResultsItem {
  constructor({
    id,
    name,
    titre_officiel,
    titre_bref,
    texte_date,
    gender,
    recruitment,
    age,
    address,
    start_date,
    created,
    study_type,
    sujets,
    phase,
    dist,
    dist_unit,
    url,
    nid,
  } = {}) {
    this.id = id;
    this.name = name;
    this.title = titre_officiel;
    this.titleShort = titre_bref;
    this.subjects = sujets || '';
    this.gender = gender || ''; // female, male, indifferent
    this.status = recruitment || '';
    this.age = age || {};
    this.address = address || '';
    this.phase = phase || '';
    this.startDate = start_date || '';
    this.createdDate = Number.isNaN(created) ? null : Number(created);
    this.type = study_type || '';
    this.url = url || '';
    this.distance = dist || null; // Number
    this.distanceUnit = dist_unit;
    this.nid = nid || '';
    this.textDate = texte_date || '';
  }

  getTitle() {
    return this.title;
  }

  getTitleShort() {
    return this.titleShort;
  }

  getSubjects() {
    return Array.isArray(this.subjects) ? this.subjects.join(', ') : this.subjects;
  }

  isNew() {
    if (!this.createdDate) {
      return false;
    }
    const sevenDays = 604800000;
    return ((this.createdDate * 1000) + sevenDays) >= new Date().getTime();
  }

  getSubject() {
    return this.subject;
  }

  getTextDate() {
    return this.textDate;
  }

  getGenderIcon() {
    const genders = {
      male: '<i class="icon icon-homme"><span class="sr-only">Homme</span></i>',
      female: '<i class="icon icon-femme"><span class="sr-only">Femme</span></i>',
      indifferent: '<i class="icon icon-femme"><span class="sr-only">Femme</span></i> + <i class="icon icon-homme"><span class="sr-only">Homme</span></i>',
    };
    return genders[this.gender] || '';
  }

  getStatus() {
    return this.status;
  }

  getMinAge() {
    return this.minAge;
  }

  getMaxAge() {
    return this.maxAge;
  }

  getAddress() {
    return this.address;
  }

  getPhase() {
    return this.phase;
  }

  getTextAge() {
    if (this.age?.ageGlobale) {
      return this.isAllAge() ? 'Tout âge' : this.age.ageGlobale;
    }
    return '';
  }

  isAllAge() {
    return this.age.ageGlobale === '0 +';
  }

  getAgeUnit() {
    return (!this.isAllAge()) && this.age?.ageUniteGlobale;
  }

  getDate() {
    return {
      created: this.createdDate ? new Date(this.createdDate * 1000).toLocaleDateString() : null,
      start: this.startDate ? new Date(this.startDate * 1000).toLocaleDateString() : null,
    };
  }

  getType() {
    return this.type;
  }

  getUrl() {
    return this.url;
  }

  getDistance() {
    return Math.round(this.distance);
  }

  getDistanceUnit() {
    return this.distanceUnit;
  }

  getId() {
    return this.nid;
  }

  hasPatientType() {
    return (
      this.gender
      || this.age
      || this.getDate().start
      || this.getPhase()
      || this.getDistance()
    );
  }
}
